import React from 'react'
import classNames from 'classnames'
import {useTranslation} from '@lib/intl/useTranslations'

import useChangeCurrency from '@hook/useCurrencyChange'
import Text from '@component/Text/Text'

import CheckIcon from '@svg/common/ic_check.svg'

interface IProps {
    className?: string
}

const CurrencySettingOperation = ({className}: IProps) => {
    const t = useTranslation()
    const {options, selectedSymbol} = useChangeCurrency()

    return (
        <div className={`text-btn_sm transition-colors duration-100 ${className}`}>
            <Text className={'mb-[5px] px-[15px] py-[10px] text-gray01 dark:text-dark_gray01'}>
                {t('globalNavigation.currency.menu.title')}
            </Text>
            {options.map(c => {
                return (
                    <div
                        key={c.id}
                        onClick={c.onClick}
                        className={
                            'flex items-center justify-between px-[15px] py-[10px] cursor-pointer hover:bg-gray08 dark:hover:bg-dark_gray08'
                        }>
                        <Text
                            className={classNames(
                                'font-normal',
                                selectedSymbol === c.id
                                    ? 'text-primary_shade dark:text-dark_primary_shade'
                                    : 'text-gray02 dark:text-dark_gray02',
                            )}>
                            {c.title}
                        </Text>
                        {selectedSymbol === c.id && (
                            <CheckIcon className={'w-[14px] fill-primary_shade dark:fill-dark_primary_shade'} />
                        )}
                    </div>
                )
            })}
        </div>
    )
}
export default CurrencySettingOperation
